var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D96EC452-79CB-4568-BC46-F10320BA5066") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SitePges",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ContentOrganization_Submitted",
    transform: "translate(-198.000000, -360.000000)",
    fill: "#FA332A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(136.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(16.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-pdf",
    transform: "translate(46.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09375,10.6875 L2.8125,10.6875 L2.8125,9 L3.09375,9 C3.56132813,9 3.9375,9.37617187 3.9375,9.84375 C3.9375,10.3113281 3.56132813,10.6875 3.09375,10.6875 Z M6.75,9 L7.03125,9 C7.340625,9 7.59375,9.253125 7.59375,9.5625 L7.59375,11.8125 C7.59375,12.121875 7.340625,12.375 7.03125,12.375 L6.75,12.375 L6.75,9 Z M7.875,0 L7.875,4.5 C7.875,5.12226562 8.37773438,5.625 9,5.625 L13.5,5.625 L13.5,15.75 C13.5,16.9910156 12.4910156,18 11.25,18 L2.25,18 C1.00722656,18 0,16.9910156 0,15.75 L0,2.25 C0,1.00722656 1.00722656,0 2.25,0 L7.875,0 Z M2.25,7.875 C1.93921875,7.875 1.6875,8.128125 1.6875,8.4375 L1.6875,12.9375 C1.6875,13.246875 1.93921875,13.5 2.25,13.5 C2.56078125,13.5 2.8125,13.246875 2.8125,12.9375 L2.8125,11.8125 L3.09375,11.8125 C4.18007813,11.8125 5.0625,10.9300781 5.0625,9.84375 C5.0625,8.75742188 4.18007813,7.875 3.09375,7.875 L2.25,7.875 Z M5.625,12.9375 C5.625,13.246875 5.878125,13.5 6.1875,13.5 L7.03125,13.5 C7.96289062,13.5 8.71875,12.7441406 8.71875,11.8125 L8.71875,9.5625 C8.71875,8.63085938 7.96289062,7.875 7.03125,7.875 L6.1875,7.875 C5.878125,7.875 5.625,8.128125 5.625,8.4375 L5.625,12.9375 Z M10.125,7.875 C9.815625,7.875 9.5625,8.128125 9.5625,8.4375 L9.5625,12.9375 C9.5625,13.246875 9.815625,13.5 10.125,13.5 C10.434375,13.5 10.6875,13.246875 10.6875,12.9375 L10.6875,11.25 L11.8125,11.25 C12.121875,11.25 12.375,10.996875 12.375,10.6875 C12.375,10.378125 12.121875,10.125 11.8125,10.125 L10.6875,10.125 L10.6875,9 L11.8125,9 C12.121875,9 12.375,8.746875 12.375,8.4375 C12.375,8.128125 12.121875,7.875 11.8125,7.875 L10.125,7.875 Z M9,0 L13.5,4.5 L9,4.5 L9,0 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.5e5449c882bf2c656a53f0d30f95e3bc.svg";
export { ForwardRef as ReactComponent };